import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { CustomBreadCrumb } from '@/components/customBreadCrumb';
import './style.scss';
import {
  CustomInput,
  CustomPagination,
  CustomSwitch,
  CustomTable,
  PaginationText,
} from '@/components';
import { FileSignature, Info, Shield } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AdminType, PricingType } from '@/DTO';
import { useAppPagination } from '@/Router/hook';
import { PricingApi } from '@/api';
import { useAppSelector } from '@/redux-config/hooks';
import { selectUser } from '@/redux-config/entities/user';
import { InsideLoading } from '@/components/loading/inside';
import { selectLanguage } from '@/redux-config/entities/language';
import { ConvertDate, ConvertNumber } from '@/utils';
import { SearchComponent } from '@/components/search';
import { CustomModal } from '@/components/custom-modal';

export const PricingList: React.FC<{}> = () => {
  const { t } = useTranslation();

  const crumbs = [
    { name: t('Dashboard'), href: '/' },
    { name: t('Pricing'), href: '#' },
    { name: t('List'), href: '#' },
  ];

  const navigate = useNavigate();
  const lang = useAppSelector(selectLanguage);
  const user = useAppSelector(selectUser);
  const [loading, setLoading] = useState<boolean>(true);

  const [data, setData] = useState<PricingType[]>([]);

  const handleGetData = () => {
    setLoading(true);
    PricingApi.GetPricingList(user)
      .then((data) => {
        setData(data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetData();
  }, []);

  return (
    <>
      <Helmet>
        <title>MahdiBookShop | Pricing List</title>
        <meta name="description" content="Basic example" />
      </Helmet>
      <div className="d-flex flex-column">
        <CustomBreadCrumb breadCrumbList={crumbs} />
        <div className="w-100 p-2">
          <div className="rounded-3 py-2 bg-custom-white h-100 d-flex flex-column justify-content-between">
            <div className={'d-flex flex-row gap-2 align-items-center'}>
              <h5 className={'p-3'}>{t('PricingList')}</h5>
            </div>
            {loading ? (
              <InsideLoading />
            ) : (
              <>
                <CustomTable
                  header={[
                    <span>{t('No')}</span>,
                    <span>{t('Size')}</span>,
                    <span>{t('PerPrice')}</span>,
                    <span>{t('BookingPrice')}</span>,
                    <span>{t('Color')}</span>,
                    <span>{t('Date')}</span>,
                    <span>{t('Options')}</span>,
                  ]}
                  items={[
                    ...data.map((item, key) => [
                      <span>{ConvertNumber(key + 1 + '', lang)}</span>,
                      <span>{item.size}</span>,
                      <span>{ConvertNumber(item.price + '', lang, true)}</span>,
                      <span>
                        {ConvertNumber(item.bookbinding_price + '', lang, true)}
                      </span>,
                      <span>
                        {item.is_multi_color
                          ? t('multi-color')
                          : t('black-white')}
                      </span>,
                      <span>{ConvertDate(item.created_at + '', lang)}</span>,
                      <div
                        className={
                          'd-flex flex-row gap-1 justify-content-center'
                        }
                      >
                        <Link
                          to={`/pricing/edit/${item.id}`}
                          className={
                            'btn p-1 align-baseline rounded-circle bg-custom-light'
                          }
                        >
                          <FileSignature />
                        </Link>
                      </div>,
                    ]),
                  ]}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
